import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import { useContentTrackContext } from '@src/components/sco/Education/ContentTrackContext';
import { TrackedVideoPlayer } from '@src/components/sco/Education/TrackedVideoPlayer';
import { ContentTrackStep } from '@src/graphql-types';
import React from 'react';
type VideoStepProps = {
  sourceUrl: string;
  playbackStartInSeconds?: number;
  playbackEndInSeconds?: number;
  contentTrackStep?: ContentTrackStep;
};
export const VideoStep = props => {
  const $ = _c(11);
  const trackContext = useContentTrackContext();
  const t0 = `${props.contentTrackStep.parentContentTrackSection?.parentContentTrack?.color?.hex}40`;
  const t1 = `${props.contentTrackStep.parentContentTrackSection.parentContentTrack.color?.hex}50`;
  const t2 = trackContext.contentTrackEnrollment?.contentTrackEnrollmentId;
  let t3;
  if ($[0] !== props.contentTrackStep.__typename || $[1] !== props.contentTrackStep.id || $[2] !== props.playbackEndInSeconds || $[3] !== props.playbackStartInSeconds || $[4] !== props.sourceUrl || $[5] !== t2) {
    t3 = <Box borderRadius="xl" boxShadow="md"><TrackedVideoPlayer key={props.sourceUrl} autoPlay={false} parentId={t2} parentType="ContentTrackEnrollment" playbackEndInSeconds={props.playbackEndInSeconds} playbackStartInSeconds={props.playbackStartInSeconds} trackScrolling={false} videoUrl={props.sourceUrl} viewableContext="video" viewableId={props.contentTrackStep.id} viewableType={props.contentTrackStep.__typename} /></Box>;
    $[0] = props.contentTrackStep.__typename;
    $[1] = props.contentTrackStep.id;
    $[2] = props.playbackEndInSeconds;
    $[3] = props.playbackStartInSeconds;
    $[4] = props.sourceUrl;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t3) {
    t4 = <Box backdropFilter="blur(5px)" bgColor={t0} borderColor={t1} borderRadius="3xl" boxShadow="0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -4px rgba(0, 0, 0, 0.5)" marginBottom={8} padding={4} transition="all 0.2s ease-in" width="full">{t3}</Box>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};